import { render } from "./ManitoResultPage.vue?vue&type=template&id=1b6769cc"
import script from "./ManitoResultPage.vue?vue&type=script&lang=js"
export * from "./ManitoResultPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__